import { Component, inject } from '@angular/core';
import { LucideAngularModule, RefreshCw, X } from 'lucide-angular';

import { AppUpdateService } from '../../../core/app-update.service';

@Component({
  selector: 'app-update-available-banner',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './update-available-banner.component.html',
  styleUrl: './update-available-banner.component.scss'
})
export class UpdateAvailableBannerComponent {
  private readonly appUpdate = inject(AppUpdateService);

  readonly icons = { refresh: RefreshCw, close: X };
  readonly updateAvailable = this.appUpdate.updateAvailable;

  reload(): void {
    this.appUpdate.applyUpdate();
  }

  dismiss(): void {
    this.appUpdate.dismissBanner();
  }
}
